import { getCookiesPolicy } from '../cookies/cookiesUtils';

/* eslint-disable camelcase */
interface OneSignalCustomWindow extends Window {
  OneSignal: any;
  oneSignalConstantConfig: {
    appId: string;
    safari_web_id: string;
  };
}
/* eslint-enable camelcase */

declare let window: OneSignalCustomWindow;

function initOneSignal() {
  try {
    window.OneSignal = window.OneSignal || [];
    window.OneSignal.push(() => {
      const { oneSignalConstantConfig } = window;

      window.OneSignal.init({
        appId: oneSignalConstantConfig.appId,
        safari_web_id: oneSignalConstantConfig.safari_web_id,
        autoRegister: false,
        notifyButton: {
          enable: false,
        },
      });
    });
  } catch (error) {
    console.log(error);
  }
}

function hasLoggedInAndAcceptedCookie() {
  const cookies = getCookiesPolicy();
  return window.logged_in && cookies && cookies.onesignal_cookie;
}

export function startOneSignal() {
  try {
    if (hasLoggedInAndAcceptedCookie()) {
      initOneSignal();
    }
  } catch (error) {
    console.log(error);
  }
}
